// import { Injectable } from '@angular/core';
// import {
//   AbstractControl,
//   FormBuilder,
//   FormControl,
//   FormGroup,
//   Validators,
// } from '@angular/forms';

// import { AuthHttpService } from '@ib-core/services/auth-http.service';
// import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
// import { environment } from '@ib-env/environment';
// import { IAuthUserCreate } from '@ib-shared/interfaces/auth-user.intf';
// import { CountriesHttpService } from '@ib-shared/services/countries-data.service';
// import { DateTimeFormatService } from '@ib-shared/services/date-time-format.service';
// import { IsPhoneAvailableAsyncValidator } from '@ib-shared/validation/async-is-phone-exist.validator';
// import { ConfirmValidator } from '@ib-shared/validation/confirm.validator';
// import { EMAIL_VALIDATION_PATTERN } from '@ib-shared/validation/email-pattern';
// import { EmailAvailabilityAsyncValidator } from '@ib-shared/validation/email-registered.validator';
// import { IbanValidator } from '@ib-shared/validation/iban.validator';
// import { passwordValidators } from '@ib-shared/validation/validators-password';
// import {
//   INVESTOR_ACCOUNT_TYPE,
//   INVESTOR_SAVING_FOR,
//   INVESTOR_WHAT_FOR,
// } from 'credebt-shared';
// import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
// import * as dayjs from 'dayjs';
// import { Subject, takeUntil } from 'rxjs';

// import { SIGN_UP_FIELDS } from '../enums/sign-up-fields.enum';
// import { SignUpStateService } from './sign-up-state.service';

// @Injectable()
// export class SignUpFormHelperService {
//   private destroy$ = new Subject<void>();

//   // ----------- GETTERS

//   get rootForm(): FormGroup {
//     return this.stateS.rootForm$.value;
//   }
//   // get isPhoneConfirmed(): boolean {
//   //   return this.getFormControl(
//   //     INVESTOR_SIGN_UP_STEPS.ADDRESS,
//   //     SIGN_UP_FIELDS.PHONE_CONFIRMED,
//   //   )?.value;
//   // }
//   get isPhoneConfirmed(): boolean {
//     return true;
//   }
//   get accountType(): INVESTOR_ACCOUNT_TYPE {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.ACCOUNT_TYPE,
//     ).value;
//   }

//   get accountTypeFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.ACCOUNT_TYPE,
//     );
//   }
//   get isCompanyAccount(): boolean {
//     return (
//       this.getFormControl(
//         INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//         SIGN_UP_FIELDS.ACCOUNT_TYPE,
//       )?.value === INVESTOR_ACCOUNT_TYPE.COMPANY
//     );
//   }
//   get phoneId(): string {
//     return this.stateS.phoneId$.value;
//   }
//   get userName(): string {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.START,
//       SIGN_UP_FIELDS.FIRST_NAME,
//     )?.value;
//   }
//   get savingForFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.SAVING_FOR,
//     );
//   }
//   get whatForFormCtrl(): FormControl {
//     return this.stateS.whatForFormCtrl;
//   }
//   get whatForAbstractFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.WHAT_FOR,
//     );
//   }
//   get phone(): string {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.START,
//       SIGN_UP_FIELDS.PHONE,
//     )?.value;
//   }
//   get phoneCountry(): string {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.START,
//       SIGN_UP_FIELDS.PHONE_COUNTRY,
//     )?.value;
//   }
//   // get isPhoneFieldValid(): boolean {
//   //   return this.getFormControl(
//   //     INVESTOR_SIGN_UP_STEPS.START,
//   //     SIGN_UP_FIELDS.PHONE,
//   //   )?.valid;
//   // }
//   get isPhoneFieldValid(): boolean {
//     return true;
//   }
//   get docsMainFormGroup(): FormGroup {
//     return this.stateS.docsMainFormGroup;
//   }
//   get docsFormGroupsMap(): Record<string, FormGroup> {
//     return this.stateS.docsFormGroupsMap;
//   }
//   get currencyBankFormCtrl(): FormControl {
//     return this.stateS.currencyBankFormCtrl;
//   }
//   get currencyBankAbstractFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.FINISH,
//       SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY,
//     );
//   }
//   get currencyHowMuchAbstractFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.HOW_MUCH_CURRENCY,
//     );
//   }
//   get currencyHowMuchFormCtrl(): FormControl {
//     return this.stateS.currencyHowMuchFormCtrl;
//   }
//   get phoneConfirmedFormCtrl(): FormControl {
//     return this.stateS.phoneConfirmedFormCtrl;
//   }
//   get phoneConfirmedAbstractFormCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.ADDRESS,
//       SIGN_UP_FIELDS.PHONE_CONFIRMED,
//     );
//   }
//   get savingForOtherFormCtrl(): FormControl {
//     return this.stateS.savingForOtherFormCtrl;
//   }
//   get savingForOtherAbstractCtrl(): AbstractControl {
//     return this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.SAVING_FOR_OTHER,
//     );
//   }

//   constructor(
//     private countriesS: CountriesHttpService,
//     private fb: FormBuilder,
//     private stateS: SignUpStateService,
//     private authHttpS: AuthHttpService,
//     private dateTimeS: DateTimeFormatService,
//   ) {}

//   public destroySubscriptions(): void {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   getFormControl(
//     step: INVESTOR_SIGN_UP_STEPS,
//     formCtrlName: SIGN_UP_FIELDS,
//   ): AbstractControl | null {
//     return this.rootForm?.get(step)?.get(formCtrlName) || null;
//   }

//   editPhone(): void {
//     this.stateS;
//     this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.START,
//       SIGN_UP_FIELDS.PHONE,
//     ).setValue('');
//     this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.ADDRESS,
//       SIGN_UP_FIELDS.PHONE_CONFIRMED,
//     ).setValue(false);
//     this.stateS.isSmsWasSentAtLeastOneTime = false;
//     this.stateS.disablePhone$.next(false);
//     this.stateS.phoneId$.next(undefined);
//   }

//   createStepForm(s: INVESTOR_SIGN_UP_STEPS): FormGroup {
//     if (s === INVESTOR_SIGN_UP_STEPS.OBJECTIVE) {
//       return this.createObjectiveForm();
//     } else if (s === INVESTOR_SIGN_UP_STEPS.START) {
//       return this.createStartForm();
//     } else if (s === INVESTOR_SIGN_UP_STEPS.ADDRESS) {
//       return this.createAddressForm();
//     } else if (s === INVESTOR_SIGN_UP_STEPS.DOCS) {
//       return this.createDocsForm();
//     } else if (s === INVESTOR_SIGN_UP_STEPS.FINISH) {
//       return this.createFinishForm();
//     } else {
//       return new FormGroup({});
//     }
//   }

//   private createStartForm(): FormGroup {
//     const fg = this.fb.group({
//       [SIGN_UP_FIELDS.EMAIL]: [
//         '',
//         [Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)],
//         [
//           EmailAvailabilityAsyncValidator.createValidator(
//             this.authHttpS,
//             FORM_ERRORS.EMAIL_NOT_AVAILABLE,
//             this.stateS.isEmailCheckLoading$,
//           ),
//         ],
//       ],
//       [SIGN_UP_FIELDS.PASSWORD]: ['', [...passwordValidators]],
//       [SIGN_UP_FIELDS.PASSWORD_REPEAT]: ['', [Validators.required]],
//       [SIGN_UP_FIELDS.FIRST_NAME]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(2),
//           Validators.maxLength(400),
//         ],
//       ],
//       [SIGN_UP_FIELDS.LAST_NAME]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(2),
//           Validators.maxLength(400),
//         ],
//       ],
//       [SIGN_UP_FIELDS.DOB]: ['', [Validators.required]],
//       [SIGN_UP_FIELDS.PHONE]: [
//         '',
//         [Validators.required],
//         [
//           IsPhoneAvailableAsyncValidator.createValidator(
//             this.authHttpS,
//             FORM_ERRORS.PHONE_NOT_AVAILABLE,
//             this.stateS.isPhoneCheckLoading$,
//           ),
//         ],
//       ],
//       [SIGN_UP_FIELDS.PHONE_COUNTRY]: ['', [Validators.required]],
//     });
//     fg.addValidators([
//       ConfirmValidator({
//         ctrlName: SIGN_UP_FIELDS.PASSWORD,
//         repeatCtrlName: SIGN_UP_FIELDS.PASSWORD_REPEAT,
//         errorName: FORM_ERRORS.PASSWORD_MATCHING,
//       }),
//     ]);
//     return fg;
//   }

//   private createObjectiveForm(): FormGroup {
//     const fg: FormGroup = this.fb.group({
//       [SIGN_UP_FIELDS.ACCOUNT_TYPE]: [undefined, [Validators.required]],
//       [SIGN_UP_FIELDS.HOW_MUCH]: [undefined, [Validators.required]],
//     });
//     fg.addControl(SIGN_UP_FIELDS.SAVING_FOR, this.stateS.savingForFormCtrl);
//     fg.addControl(SIGN_UP_FIELDS.WHAT_FOR, this.stateS.whatForFormCtrl);
//     fg.addControl(
//       SIGN_UP_FIELDS.WHAT_FOR_OTHER,
//       this.stateS.whatForOtherFormCtrl,
//     );
//     fg.addControl(
//       SIGN_UP_FIELDS.HOW_MUCH_CURRENCY,
//       this.stateS.currencyHowMuchFormCtrl,
//     );
//     return fg;
//   }

//   private createFinishForm(): FormGroup {
//     const fg: FormGroup = this.fb.group({
//       [SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(5),
//           Validators.maxLength(400),
//         ],
//       ],
//       [SIGN_UP_FIELDS.ACCOUNT_IBAN]: [
//         '',
//         [Validators.required, IbanValidator()],
//       ],
//     });
//     fg.addControl(
//       SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY,
//       this.stateS.currencyBankFormCtrl,
//     );
//     return fg;
//   }

//   private createAddressForm(): FormGroup {
//     const fg: FormGroup = this.fb.group({
//       [SIGN_UP_FIELDS.COUNTRY_CODE]: ['', [Validators.required]],
//       [SIGN_UP_FIELDS.STREET_AND_NUMBER]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(3),
//           Validators.maxLength(200),
//         ],
//       ],
//       [SIGN_UP_FIELDS.CITY]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(2),
//           Validators.maxLength(200),
//         ],
//       ],
//       [SIGN_UP_FIELDS.POSTAL_ZIP_CODE]: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(2),
//           Validators.maxLength(40),
//         ],
//       ],
//     });
//     fg.addControl(
//       SIGN_UP_FIELDS.PHONE_CONFIRMED,
//       this.stateS.phoneConfirmedFormCtrl,
//     );
//     return fg;
//   }

//   private createDocsForm(): FormGroup {
//     const fg: FormGroup = this.fb.group({
//       [SIGN_UP_FIELDS.DOC_TYPE]: [undefined, [Validators.required]],
//     });

//     fg.addControl(SIGN_UP_FIELDS.PERSON_PPS, this.stateS.ppsFormCtrl);
//     fg.addControl(SIGN_UP_FIELDS.COMPANY_VAT, this.stateS.vatFormCtrl);
//     fg.addControl(SIGN_UP_FIELDS.DOCUMENTS_LIST, this.stateS.docsMainFormGroup);
//     return fg;
//   }

//   // after init all controls
//   createFormCtrlChangeListeners(): void {
//     this.watchQuestionsByAccType();
//     this.watchWhatForChange();
//     this.watchSavingForByAccType();
//     this.watchSavingForOther();
//     this.watchDocTypesByAccType();
//   }

//   private watchSavingForByAccType(): void {
//     let prevForPersonal;
//     let prevForCompany;
//     // set prev value
//     this.rootForm
//       .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
//       .get(SIGN_UP_FIELDS.ACCOUNT_TYPE)
//       .valueChanges.pipe(takeUntil(this.destroy$))
//       .subscribe(accType => {
//         if (accType) {
//           const ctrl = this.getFormControl(
//             INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//             SIGN_UP_FIELDS.SAVING_FOR,
//           );
//           if (accType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//             if (prevForPersonal) {
//               ctrl.setValue(prevForPersonal);
//             }
//           } else if (accType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//             if (prevForCompany) {
//               ctrl.setValue(prevForCompany);
//             }
//           }
//           this.initSavingForOtherByAccType();
//           (
//             this.rootForm.get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE) as FormGroup
//           ).updateValueAndValidity();
//           this.rootForm.updateValueAndValidity();
//         }
//       });
//     // save prev value
//     this.rootForm
//       .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
//       .get(SIGN_UP_FIELDS.SAVING_FOR)
//       .valueChanges.pipe(takeUntil(this.destroy$))
//       .subscribe(savingFor => {
//         if (savingFor) {
//           if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//             prevForPersonal = savingFor;
//           } else if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//             prevForCompany = savingFor;
//           }
//         }
//       });
//   }

//   private watchDocTypesByAccType(): void {
//     this.rootForm
//       .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
//       .get(SIGN_UP_FIELDS.ACCOUNT_TYPE)
//       .valueChanges.pipe(takeUntil(this.destroy$))
//       .subscribe(v => {
//         if (v) {
//           this.initIdentificationNumberType();
//         }
//       });
//   }

//   private watchSavingForOther(): void {
//     this.rootForm
//       .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
//       .get(SIGN_UP_FIELDS.SAVING_FOR)
//       .valueChanges.pipe(takeUntil(this.destroy$))
//       .subscribe(v => {
//         if (v) {
//           this.initSavingForOtherByAccType();
//         }
//       });
//   }

//   public watchQuestionsByAccType(): void {
//     this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.ACCOUNT_TYPE,
//     )
//       .valueChanges.pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.initWhatForByAccType();
//         this.initSavingForOtherByAccType();
//       });
//   }

//   private watchWhatForChange(): void {
//     this.whatForFormCtrl.valueChanges
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.initToggleWhatForOther();
//       });
//   }

//   initWhatForByAccType(): void {
//     const objForm = this.rootForm.get(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//     ) as FormGroup;
//     const val = this.getFormControl(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//       SIGN_UP_FIELDS.ACCOUNT_TYPE,
//     ).value as INVESTOR_ACCOUNT_TYPE;
//     if (val === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//       objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR);
//       objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR_OTHER);
//     } else if (val === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//       objForm.addControl(SIGN_UP_FIELDS.WHAT_FOR, this.stateS.whatForFormCtrl);
//       this.initToggleWhatForOther();
//     }
//     objForm.updateValueAndValidity();
//     this.rootForm.updateValueAndValidity();
//   }

//   initSavingForOtherByAccType(): void {
//     const objForm = this.rootForm.get(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//     ) as FormGroup;
//     objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
//     if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//       const isOtherSelected =
//         this.getFormControl(
//           INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//           SIGN_UP_FIELDS.SAVING_FOR,
//         ).value === INVESTOR_SAVING_FOR.OTHER;
//       if (isOtherSelected) {
//         objForm.addControl(
//           SIGN_UP_FIELDS.SAVING_FOR_OTHER,
//           this.stateS.savingForOtherFormCtrl,
//         );
//       } else {
//         objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
//       }
//     } else if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//       objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
//     }
//     objForm.updateValueAndValidity();
//     this.rootForm.updateValueAndValidity();
//   }

//   initToggleWhatForOther(): void {
//     const objForm = this.rootForm.get(
//       INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
//     ) as FormGroup;
//     const val = this.whatForFormCtrl.value;
//     if (val === INVESTOR_WHAT_FOR.OTHER) {
//       objForm.addControl(
//         SIGN_UP_FIELDS.WHAT_FOR_OTHER,
//         this.stateS.whatForOtherFormCtrl,
//       );
//     } else {
//       objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR_OTHER);
//     }
//   }

//   public initIdentificationNumberType(): void {
//     const v = this.accountType;

//     if (v) {
//       if (v === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//         this.stateS.ppsFormCtrl.setValidators(this.stateS.ppsValidators);
//         this.stateS.vatFormCtrl.setValidators([]);
//         // mocks
//         if (!environment.production && environment.allowSignUpUseMocks) {
//           this.rootForm
//             .get(INVESTOR_SIGN_UP_STEPS.DOCS)
//             .get(SIGN_UP_FIELDS.PERSON_PPS)
//             .setValue('1234567w');
//         }
//       } else if (v === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//         this.stateS.ppsFormCtrl.setValidators([]);
//         this.stateS.vatFormCtrl.setValidators(this.stateS.vatValidators);
//       } else {
//         throw new Error('Not defined user role');
//       }
//     } else {
//       this.stateS.ppsFormCtrl.setValidators([]);
//       this.stateS.vatFormCtrl.setValidators([]);
//     }
//     this.stateS.ppsFormCtrl.updateValueAndValidity();
//     this.stateS.vatFormCtrl.updateValueAndValidity();
//   }

//   // -------------- PAYLOAD

//   public createStepSignUpPayload(
//     step: INVESTOR_SIGN_UP_STEPS,
//   ): Partial<IAuthUserCreate> {
//     const formRaw = this.rootForm.getRawValue();
//     const payload: Partial<IAuthUserCreate> = {};
//     if (step === INVESTOR_SIGN_UP_STEPS.OBJECTIVE) {
//       payload.accountType =
//         formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.ACCOUNT_TYPE];
//       const savingFor =
//         formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.SAVING_FOR];
//       payload.savingFor = savingFor;

//       if (this.isCompanyAccount && savingFor === INVESTOR_SAVING_FOR.OTHER) {
//         payload.savingForOther =
//           formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
//             SIGN_UP_FIELDS.SAVING_FOR_OTHER
//           ];
//       }
//       payload.savingWhatFor = !this.isCompanyAccount
//         ? formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.WHAT_FOR]
//         : undefined;
//       payload.savingWhatForOther =
//         !this.isCompanyAccount &&
//         formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.WHAT_FOR] ===
//           INVESTOR_WHAT_FOR.OTHER
//           ? formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
//               SIGN_UP_FIELDS.WHAT_FOR_OTHER
//             ]
//           : undefined;
//       payload.savingHowMuch =
//         formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.HOW_MUCH];
//       payload.savingHowMuchCurrency =
//         formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
//           SIGN_UP_FIELDS.HOW_MUCH_CURRENCY
//         ];
//     } else if (step === INVESTOR_SIGN_UP_STEPS.START) {
//       payload.email =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.EMAIL];
//       payload.password =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PASSWORD];
//       payload.firstName =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.FIRST_NAME];
//       payload.lastName =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.LAST_NAME];
//       payload.name = `${
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.FIRST_NAME]
//       } ${formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.LAST_NAME]}`;
//       payload.dob = dayjs(
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.DOB],
//       ).format(this.dateTimeS.getDateFormatForApi());
//       payload.phone =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PHONE];
//       payload.phoneCountry =
//         formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PHONE_COUNTRY];
//     } else if (step === INVESTOR_SIGN_UP_STEPS.ADDRESS) {
//       payload.countryCode =
//         formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.COUNTRY_CODE];
//       payload.streetAndNumber =
//         formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][
//           SIGN_UP_FIELDS.STREET_AND_NUMBER
//         ];
//       payload.city =
//         formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.CITY];
//       payload.postalZip =
//         formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.POSTAL_ZIP_CODE];
//     } else if (step === INVESTOR_SIGN_UP_STEPS.DOCS) {
//       if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
//         payload.vat =
//           formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.COMPANY_VAT];
//       }
//       if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
//         payload.pps =
//           formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.PERSON_PPS];
//       }
//       payload.docType =
//         formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.DOC_TYPE];
//     } else if (step === INVESTOR_SIGN_UP_STEPS.FINISH) {
//       payload.bankCurrency =
//         formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][
//           SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY
//         ];
//       payload.bankHolderName =
//         formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][
//           SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME
//         ];
//       payload.bankIban =
//         formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][SIGN_UP_FIELDS.ACCOUNT_IBAN];
//     }
//     payload.registrationIp = this.countriesS.ipAddress || 'Not Detected';
//     return payload;
//   }

//   public createSignUpPayload(): IAuthUserCreate {
//     const payload: IAuthUserCreate = {
//       ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.OBJECTIVE),
//       ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.START),
//       ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.ADDRESS),
//       ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.DOCS),
//       ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.FINISH),
//     } as IAuthUserCreate;
//     payload.registrationIp = this.countriesS.ipAddress || 'Not Detected';
//     return payload;
//   }
// }

import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';


import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import { environment } from '@ib-env/environment';
import { IAuthUserCreate } from '@ib-shared/interfaces/auth-user.intf';
import { CountriesHttpService } from '@ib-shared/services/countries-data.service';
import { DateTimeFormatService } from '@ib-shared/services/date-time-format.service';
import { IsPhoneAvailableAsyncValidator } from '@ib-shared/validation/async-is-phone-exist.validator';
import { ConfirmValidator } from '@ib-shared/validation/confirm.validator';
import { EMAIL_VALIDATION_PATTERN } from '@ib-shared/validation/email-pattern';
import { EmailAvailabilityAsyncValidator } from '@ib-shared/validation/email-registered.validator';
import { IbanValidator } from '@ib-shared/validation/iban.validator';
import { passwordValidators } from '@ib-shared/validation/validators-password';
import {
  INVESTOR_ACCOUNT_TYPE,
  INVESTOR_SAVING_FOR,
  INVESTOR_WHAT_FOR,
} from 'credebt-shared';
import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
import * as dayjs from 'dayjs';
import { Subject, takeUntil } from 'rxjs';


import { SIGN_UP_FIELDS } from '../enums/sign-up-fields.enum';
import { SignUpStateService } from './sign-up-state.service';


@Injectable()
export class SignUpFormHelperService {
  private destroy$ = new Subject<void>();


  // ----------- GETTERS


  get rootForm(): FormGroup {
    return this.stateS.rootForm$.value;
  }
  get isPhoneConfirmed(): boolean {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.ADDRESS,
      SIGN_UP_FIELDS.PHONE_CONFIRMED,
    )?.value;
  }
  get accountType(): INVESTOR_ACCOUNT_TYPE {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.ACCOUNT_TYPE,
    ).value;
  }


  get accountTypeFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.ACCOUNT_TYPE,
    );
  }
  get isCompanyAccount(): boolean {
    return (
      this.getFormControl(
        INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
        SIGN_UP_FIELDS.ACCOUNT_TYPE,
      )?.value === INVESTOR_ACCOUNT_TYPE.COMPANY
    );
  }
  get phoneId(): string {
    return this.stateS.phoneId$.value;
  }
  get userName(): string {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.START,
      SIGN_UP_FIELDS.FIRST_NAME,
    )?.value;
  }
  get savingForFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.SAVING_FOR,
    );
  }
  get whatForFormCtrl(): FormControl {
    return this.stateS.whatForFormCtrl;
  }
  get whatForAbstractFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.WHAT_FOR,
    );
  }
  get phone(): string {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.START,
      SIGN_UP_FIELDS.PHONE,
    )?.value;
  }
  get phoneCountry(): string {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.START,
      SIGN_UP_FIELDS.PHONE_COUNTRY,
    )?.value;
  }
  get isPhoneFieldValid(): boolean {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.START,
      SIGN_UP_FIELDS.PHONE,
    )?.valid;
  }
  get docsMainFormGroup(): FormGroup {
    return this.stateS.docsMainFormGroup;
  }
  get docsFormGroupsMap(): Record<string, FormGroup> {
    return this.stateS.docsFormGroupsMap;
  }
  get currencyBankFormCtrl(): FormControl {
    return this.stateS.currencyBankFormCtrl;
  }
  get currencyBankAbstractFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.FINISH,
      SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY,
    );
  }
  get currencyHowMuchAbstractFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.HOW_MUCH_CURRENCY,
    );
  }
  get currencyHowMuchFormCtrl(): FormControl {
    return this.stateS.currencyHowMuchFormCtrl;
  }
  get phoneConfirmedFormCtrl(): FormControl {
    return this.stateS.phoneConfirmedFormCtrl;
  }
  get phoneConfirmedAbstractFormCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.ADDRESS,
      SIGN_UP_FIELDS.PHONE_CONFIRMED,
    );
  }
  get savingForOtherFormCtrl(): FormControl {
    return this.stateS.savingForOtherFormCtrl;
  }
  get savingForOtherAbstractCtrl(): AbstractControl {
    return this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.SAVING_FOR_OTHER,
    );
  }


  constructor(
    private countriesS: CountriesHttpService,
    private fb: FormBuilder,
    private stateS: SignUpStateService,
    private authHttpS: AuthHttpService,
    private dateTimeS: DateTimeFormatService,
  ) {}


  public destroySubscriptions(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getFormControl(
    step: INVESTOR_SIGN_UP_STEPS,
    formCtrlName: SIGN_UP_FIELDS,
  ): AbstractControl | null {
    return this.rootForm?.get(step)?.get(formCtrlName) || null;
  }


  editPhone(): void {
    this.stateS;
    this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.START,
      SIGN_UP_FIELDS.PHONE,
    ).setValue('');
    this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.ADDRESS,
      SIGN_UP_FIELDS.PHONE_CONFIRMED,
    ).setValue(false);
    this.stateS.isSmsWasSentAtLeastOneTime = false;
    this.stateS.disablePhone$.next(false);
    this.stateS.phoneId$.next(undefined);
  }


  createStepForm(s: INVESTOR_SIGN_UP_STEPS): FormGroup {
    if (s === INVESTOR_SIGN_UP_STEPS.OBJECTIVE) {
      return this.createObjectiveForm();
    } else if (s === INVESTOR_SIGN_UP_STEPS.START) {
      return this.createStartForm();
    } else if (s === INVESTOR_SIGN_UP_STEPS.ADDRESS) {
      return this.createAddressForm();
    } else if (s === INVESTOR_SIGN_UP_STEPS.DOCS) {
      return this.createDocsForm();
    } else if (s === INVESTOR_SIGN_UP_STEPS.FINISH) {
      return this.createFinishForm();
    } else {
      return new FormGroup({});
    }
  }


  private createStartForm(): FormGroup {
    const fg = this.fb.group({
      [SIGN_UP_FIELDS.EMAIL]: [
        '',
        [Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)],
        [
          EmailAvailabilityAsyncValidator.createValidator(
            this.authHttpS,
            FORM_ERRORS.EMAIL_NOT_AVAILABLE,
            this.stateS.isEmailCheckLoading$,
          ),
        ],
      ],
      [SIGN_UP_FIELDS.PASSWORD]: ['', [...passwordValidators]],
      [SIGN_UP_FIELDS.PASSWORD_REPEAT]: ['', [Validators.required]],
      [SIGN_UP_FIELDS.FIRST_NAME]: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(400),
        ],
      ],
      [SIGN_UP_FIELDS.LAST_NAME]: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(400),
        ],
      ],
      [SIGN_UP_FIELDS.DOB]: ['', [Validators.required]],
      [SIGN_UP_FIELDS.PHONE]: [
        '',
        [Validators.required],
        [
          IsPhoneAvailableAsyncValidator.createValidator(
            this.authHttpS,
            FORM_ERRORS.PHONE_NOT_AVAILABLE,
            this.stateS.isPhoneCheckLoading$,
          ),
        ],
      ],
      [SIGN_UP_FIELDS.PHONE_COUNTRY]: ['', [Validators.required]],
    });
    fg.addValidators([
      ConfirmValidator({
        ctrlName: SIGN_UP_FIELDS.PASSWORD,
        repeatCtrlName: SIGN_UP_FIELDS.PASSWORD_REPEAT,
        errorName: FORM_ERRORS.PASSWORD_MATCHING,
      }),
    ]);
    return fg;
  }


  private createObjectiveForm(): FormGroup {
    const fg: FormGroup = this.fb.group({
      [SIGN_UP_FIELDS.ACCOUNT_TYPE]: [undefined, [Validators.required]],
      [SIGN_UP_FIELDS.HOW_MUCH]: [undefined, [Validators.required]],
    });
    fg.addControl(SIGN_UP_FIELDS.SAVING_FOR, this.stateS.savingForFormCtrl);
    fg.addControl(SIGN_UP_FIELDS.WHAT_FOR, this.stateS.whatForFormCtrl);
    fg.addControl(
      SIGN_UP_FIELDS.WHAT_FOR_OTHER,
      this.stateS.whatForOtherFormCtrl,
    );
    fg.addControl(
      SIGN_UP_FIELDS.HOW_MUCH_CURRENCY,
      this.stateS.currencyHowMuchFormCtrl,
    );
    return fg;
  }


  private createFinishForm(): FormGroup {
    const fg: FormGroup = this.fb.group({
      [SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME]: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(400),
        ],
      ],
      [SIGN_UP_FIELDS.ACCOUNT_IBAN]: [
        '',
        [Validators.required, IbanValidator()],
      ],
    });
    fg.addControl(
      SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY,
      this.stateS.currencyBankFormCtrl,
    );
    return fg;
  }


  private createAddressForm(): FormGroup {
    const fg: FormGroup = this.fb.group({
      [SIGN_UP_FIELDS.COUNTRY_CODE]: ['', [Validators.required]],
      [SIGN_UP_FIELDS.STREET_AND_NUMBER]: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(200),
        ],
      ],
      [SIGN_UP_FIELDS.CITY]: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(200),
        ],
      ],
      [SIGN_UP_FIELDS.POSTAL_ZIP_CODE]: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(40),
        ],
      ],
    });
    fg.addControl(
      SIGN_UP_FIELDS.PHONE_CONFIRMED,
      this.stateS.phoneConfirmedFormCtrl,
    );
    return fg;
  }


  private createDocsForm(): FormGroup {
    const fg: FormGroup = this.fb.group({
      [SIGN_UP_FIELDS.DOC_TYPE]: [undefined, [Validators.required]],
    });


    fg.addControl(SIGN_UP_FIELDS.PERSON_PPS, this.stateS.ppsFormCtrl);
    fg.addControl(SIGN_UP_FIELDS.COMPANY_VAT, this.stateS.vatFormCtrl);
    fg.addControl(SIGN_UP_FIELDS.DOCUMENTS_LIST, this.stateS.docsMainFormGroup);
    return fg;
  }


  // after init all controls
  createFormCtrlChangeListeners(): void {
    this.watchQuestionsByAccType();
    this.watchWhatForChange();
    this.watchSavingForByAccType();
    this.watchSavingForOther();
    this.watchDocTypesByAccType();
  }


  private watchSavingForByAccType(): void {
    let prevForPersonal;
    let prevForCompany;
    // set prev value
    this.rootForm
      .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
      .get(SIGN_UP_FIELDS.ACCOUNT_TYPE)
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(accType => {
        if (accType) {
          const ctrl = this.getFormControl(
            INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
            SIGN_UP_FIELDS.SAVING_FOR,
          );
          if (accType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
            if (prevForPersonal) {
              ctrl.setValue(prevForPersonal);
            }
          } else if (accType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
            if (prevForCompany) {
              ctrl.setValue(prevForCompany);
            }
          }
          this.initSavingForOtherByAccType();
          (
            this.rootForm.get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE) as FormGroup
          ).updateValueAndValidity();
          this.rootForm.updateValueAndValidity();
        }
      });
    // save prev value
    this.rootForm
      .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
      .get(SIGN_UP_FIELDS.SAVING_FOR)
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(savingFor => {
        if (savingFor) {
          if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
            prevForPersonal = savingFor;
          } else if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
            prevForCompany = savingFor;
          }
        }
      });
  }


  private watchDocTypesByAccType(): void {
    this.rootForm
      .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
      .get(SIGN_UP_FIELDS.ACCOUNT_TYPE)
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(v => {
        if (v) {
          this.initIdentificationNumberType();
        }
      });
  }


  private watchSavingForOther(): void {
    this.rootForm
      .get(INVESTOR_SIGN_UP_STEPS.OBJECTIVE)
      .get(SIGN_UP_FIELDS.SAVING_FOR)
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(v => {
        if (v) {
          this.initSavingForOtherByAccType();
        }
      });
  }


  public watchQuestionsByAccType(): void {
    this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.ACCOUNT_TYPE,
    )
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.initWhatForByAccType();
        this.initSavingForOtherByAccType();
      });
  }


  private watchWhatForChange(): void {
    this.whatForFormCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.initToggleWhatForOther();
      });
  }


  initWhatForByAccType(): void {
    const objForm = this.rootForm.get(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
    ) as FormGroup;
    const val = this.getFormControl(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
      SIGN_UP_FIELDS.ACCOUNT_TYPE,
    ).value as INVESTOR_ACCOUNT_TYPE;
    if (val === INVESTOR_ACCOUNT_TYPE.COMPANY) {
      objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR);
      objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR_OTHER);
    } else if (val === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
      objForm.addControl(SIGN_UP_FIELDS.WHAT_FOR, this.stateS.whatForFormCtrl);
      this.initToggleWhatForOther();
    }
    objForm.updateValueAndValidity();
    this.rootForm.updateValueAndValidity();
  }


  initSavingForOtherByAccType(): void {
    const objForm = this.rootForm.get(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
    ) as FormGroup;
    objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
    if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
      const isOtherSelected =
        this.getFormControl(
          INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
          SIGN_UP_FIELDS.SAVING_FOR,
        ).value === INVESTOR_SAVING_FOR.OTHER;
      if (isOtherSelected) {
        objForm.addControl(
          SIGN_UP_FIELDS.SAVING_FOR_OTHER,
          this.stateS.savingForOtherFormCtrl,
        );
      } else {
        objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
      }
    } else if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
      objForm.removeControl(SIGN_UP_FIELDS.SAVING_FOR_OTHER);
    }
    objForm.updateValueAndValidity();
    this.rootForm.updateValueAndValidity();
  }


  initToggleWhatForOther(): void {
    const objForm = this.rootForm.get(
      INVESTOR_SIGN_UP_STEPS.OBJECTIVE,
    ) as FormGroup;
    const val = this.whatForFormCtrl.value;
    if (val === INVESTOR_WHAT_FOR.OTHER) {
      objForm.addControl(
        SIGN_UP_FIELDS.WHAT_FOR_OTHER,
        this.stateS.whatForOtherFormCtrl,
      );
    } else {
      objForm.removeControl(SIGN_UP_FIELDS.WHAT_FOR_OTHER);
    }
  }


  public initIdentificationNumberType(): void {
    const v = this.accountType;


    if (v) {
      if (v === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
        this.stateS.ppsFormCtrl.setValidators(this.stateS.ppsValidators);
        this.stateS.vatFormCtrl.setValidators([]);
        // mocks
        if (!environment.production && environment.allowSignUpUseMocks) {
          this.rootForm
            .get(INVESTOR_SIGN_UP_STEPS.DOCS)
            .get(SIGN_UP_FIELDS.PERSON_PPS)
            .setValue('1234567w');
        }
      } else if (v === INVESTOR_ACCOUNT_TYPE.COMPANY) {
        this.stateS.ppsFormCtrl.setValidators([]);
        this.stateS.vatFormCtrl.setValidators(this.stateS.vatValidators);
      } else {
        throw new Error('Not defined user role');
      }
    } else {
      this.stateS.ppsFormCtrl.setValidators([]);
      this.stateS.vatFormCtrl.setValidators([]);
    }
    this.stateS.ppsFormCtrl.updateValueAndValidity();
    this.stateS.vatFormCtrl.updateValueAndValidity();
  }


  // -------------- PAYLOAD


  public createStepSignUpPayload(
    step: INVESTOR_SIGN_UP_STEPS,
  ): Partial<IAuthUserCreate> {
    const formRaw = this.rootForm.getRawValue();
    const payload: Partial<IAuthUserCreate> = {};
    if (step === INVESTOR_SIGN_UP_STEPS.OBJECTIVE) {
      payload.accountType =
        formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.ACCOUNT_TYPE];
      const savingFor =
        formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.SAVING_FOR];
      payload.savingFor = savingFor;


      if (this.isCompanyAccount && savingFor === INVESTOR_SAVING_FOR.OTHER) {
        payload.savingForOther =
          formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
            SIGN_UP_FIELDS.SAVING_FOR_OTHER
          ];
      }
      payload.savingWhatFor = !this.isCompanyAccount
        ? formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.WHAT_FOR]
        : undefined;
      payload.savingWhatForOther =
        !this.isCompanyAccount &&
        formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.WHAT_FOR] ===
          INVESTOR_WHAT_FOR.OTHER
          ? formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
              SIGN_UP_FIELDS.WHAT_FOR_OTHER
            ]
          : undefined;
      payload.savingHowMuch =
        formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][SIGN_UP_FIELDS.HOW_MUCH];
      payload.savingHowMuchCurrency =
        formRaw[INVESTOR_SIGN_UP_STEPS.OBJECTIVE][
          SIGN_UP_FIELDS.HOW_MUCH_CURRENCY
        ];
    } else if (step === INVESTOR_SIGN_UP_STEPS.START) {
      payload.email =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.EMAIL];
      payload.password =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PASSWORD];
      payload.firstName =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.FIRST_NAME];
      payload.lastName =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.LAST_NAME];
      payload.name = `${
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.FIRST_NAME]
      } ${formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.LAST_NAME]}`;
      payload.dob = dayjs(
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.DOB],
      ).format(this.dateTimeS.getDateFormatForApi());
      payload.phone =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PHONE];
      payload.phoneCountry =
        formRaw[INVESTOR_SIGN_UP_STEPS.START][SIGN_UP_FIELDS.PHONE_COUNTRY];
    } else if (step === INVESTOR_SIGN_UP_STEPS.ADDRESS) {
      payload.countryCode =
        formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.COUNTRY_CODE];
      payload.streetAndNumber =
        formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][
          SIGN_UP_FIELDS.STREET_AND_NUMBER
        ];
      payload.city =
        formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.CITY];
      payload.postalZip =
        formRaw[INVESTOR_SIGN_UP_STEPS.ADDRESS][SIGN_UP_FIELDS.POSTAL_ZIP_CODE];
    } else if (step === INVESTOR_SIGN_UP_STEPS.DOCS) {
      if (this.accountType === INVESTOR_ACCOUNT_TYPE.COMPANY) {
        payload.vat =
          formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.COMPANY_VAT];
      }
      if (this.accountType === INVESTOR_ACCOUNT_TYPE.PERSONAL) {
        payload.pps =
          formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.PERSON_PPS];
      }
      payload.docType =
        formRaw[INVESTOR_SIGN_UP_STEPS.DOCS][SIGN_UP_FIELDS.DOC_TYPE];
    } else if (step === INVESTOR_SIGN_UP_STEPS.FINISH) {
      payload.bankCurrency =
        formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][
          SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY
        ];
      payload.bankHolderName =
        formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][
          SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME
        ];
      payload.bankIban =
        formRaw[INVESTOR_SIGN_UP_STEPS.FINISH][SIGN_UP_FIELDS.ACCOUNT_IBAN];
    }
    payload.registrationIp = this.countriesS.ipAddress || 'Not Detected';
    return payload;
  }


  public createSignUpPayload(): IAuthUserCreate {
    const payload: IAuthUserCreate = {
      ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.OBJECTIVE),
      ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.START),
      ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.ADDRESS),
      ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.DOCS),
      ...this.createStepSignUpPayload(INVESTOR_SIGN_UP_STEPS.FINISH),
    } as IAuthUserCreate;
    payload.registrationIp = this.countriesS.ipAddress || 'Not Detected';
    return payload;
  }
}



